let isExpanded = false;

const showTopic = (topicHandle, topicName) => {
  const tabsContent = document.querySelector('.tabs__content-items');
  const topicNameEl = document.querySelector('.tabs__content-topic-name');
  const allItems = document.querySelectorAll('.tabs__item');
  const expandAllBtn = document.querySelector('.tabs__expand-all');
  
  if (topicNameEl) {
    topicNameEl.textContent = topicName;
  }
  
  isExpanded = false;
  if (expandAllBtn) {
    expandAllBtn.textContent = 'Expand All';
  }
  
  allItems.forEach((item) => {
    item.classList.remove('tabs__item--active');
    item.classList.add('tabs__item--inactive');
  });
  
  const matchingItems = tabsContent.querySelectorAll(`[data-topic="${topicHandle}"]`);
  matchingItems.forEach((item) => {
    item.classList.remove('tabs__item--inactive');
    item.classList.add('tabs__item--active');
  });
  
  collapseAll();
  
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

const expandAll = () => {
  const activeItems = document.querySelectorAll('.tabs__item--active .details');
  activeItems.forEach((item) => {
    if (!item.classList.contains('details--active')) {
      item.classList.add('details--active');
      const button = item.querySelector('.summary');
      const content = item.querySelector('.details__content');
      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }
      if (content) {
        content.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = '';
      }
    }
  });
};

const collapseAll = () => {
  const activeItems = document.querySelectorAll('.tabs__item--active .details');
  activeItems.forEach((item) => {
    if (item.classList.contains('details--active')) {
      item.classList.remove('details--active');
      const button = item.querySelector('.summary');
      const content = item.querySelector('.details__content');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
      if (content) {
        content.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '';
      }
    }
  });
};

const updateActiveState = (topicHandle, topicName) => {
  const topicTriggers = document.querySelectorAll('.tabs__header .topic-trigger');
  topicTriggers.forEach((tab) => tab.classList.remove('link-styled--active'));
  const activeTrigger = document.querySelector(`.topic-trigger[data-topic="${topicHandle}"]`);
  if (activeTrigger) {
    activeTrigger.classList.add('link-styled--active');
  }
  
  const select = document.getElementById('TabsHeaderSelect');
  if (select) {
    select.value = topicHandle;
  }
  
  showTopic(topicHandle, topicName);
  
  window.location.hash = topicHandle;
};

(() => {
  const topicTriggers = document.querySelectorAll('.tabs__header .topic-trigger');
  
  topicTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const topicHandle = trigger.dataset.topic;
      const topicName = trigger.textContent.trim();
      updateActiveState(topicHandle, topicName);
    });
  });

  const select = document.getElementById('TabsHeaderSelect');
  if (select) {
    select.addEventListener('change', (e) => {
      const topicHandle = e.target.value;
      const selectedOption = e.target.options[e.target.selectedIndex];
      const topicName = selectedOption.textContent.trim();
      updateActiveState(topicHandle, topicName);
    });
  }

  const expandAllBtn = document.querySelector('.tabs__expand-all');
  
  if (expandAllBtn) {
    expandAllBtn.addEventListener('click', () => {
      if (isExpanded) {
        collapseAll();
        expandAllBtn.textContent = 'Expand All';
        isExpanded = false;
      } else {
        expandAll();
        expandAllBtn.textContent = 'Collapse All';
        isExpanded = true;
      }
    });
  }

  const hash = window.location.hash;
  
  if (hash) {
    const topicHandle = hash.slice(1);
    const trigger = document.querySelector(`.topic-trigger[data-topic="${topicHandle}"]`);
    
    if (trigger) {
      const topicName = trigger.textContent.trim();
      updateActiveState(topicHandle, topicName);
    } else {
      const firstTrigger = document.querySelector('.tabs__header .topic-trigger');
      if (firstTrigger) {
        const topicHandle = firstTrigger.dataset.topic;
        const topicName = firstTrigger.textContent.trim();
        updateActiveState(topicHandle, topicName);
      }
    }
  } else {
    setTimeout(() => {
      const firstTrigger = document.querySelector('.tabs__header .topic-trigger');
      if (firstTrigger) {
        const topicHandle = firstTrigger.dataset.topic;
        const topicName = firstTrigger.textContent.trim();
        updateActiveState(topicHandle, topicName);
      }
    }, 100);
  }
})();

// Account page tabs 
(() => {
  const containers = document.querySelectorAll('.customer.account.tabs');
  if (!containers.length) return;

  containers.forEach((section) => {
    const tabTriggers = section.querySelectorAll('.tab-trigger[data-trigger]');
    const tabItems = section.querySelectorAll('.tabs__item');
    const select = section.querySelector('#TabsSidebarSelect');
    const overviewBanner = document.querySelector('.account-overview-banner');

    const activateTab = (handle) => {
      tabTriggers.forEach((trigger) => {
        trigger.classList.toggle(
          'link-styled--active',
          trigger.dataset.trigger === handle
        );
      });

      tabItems.forEach((item) => {
        if (item.id === handle) {
          item.classList.add('tabs__item--active');
        } else {
          item.classList.remove('tabs__item--active');
        }
      });

      if (select && select.value !== handle) {
        select.value = handle;
      }

      if (overviewBanner) {
        if (handle === 'overview') {
          overviewBanner.classList.remove('account-overview-banner--hidden');
        } else {
          overviewBanner.classList.add('account-overview-banner--hidden');
        }
      }
    };

    tabTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const handle = trigger.dataset.trigger;
        if (!handle) return;
        activateTab(handle);
      });
    });

    if (select) {
      select.addEventListener('change', (event) => {
        const option = event.target.selectedOptions[0];
        const handle = option.value;
        const href = option.dataset.href;

        if (href) {
          window.location.href = href;
          return;
        }

        activateTab(handle);
      });
    }

    // Overview is the default tab on account page
    const initialHandle = window.location.hash.replace('#', '') || 'overview';
    activateTab(initialHandle);

    // Allow "Edit" links in Overview to jump to specific tabs
    const overviewEditButtons = section.querySelectorAll('.account-overview-edit[data-target-tab]');
    overviewEditButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.targetTab;
        if (!target) return;
        activateTab(target);
      });
    });
  });
})();